const IMAGES_URL = 'static/images/movix-new';
const FILMS_URL = `${IMAGES_URL}/films/`;
const KIDS_URL = `${IMAGES_URL}/kids/`;
const SERIALS_URL = `${IMAGES_URL}/serials/`;
const SPORT_URL = `${IMAGES_URL}/sport/`;
const TV_CHANNELS_URL = `${IMAGES_URL}/tv-channels/`;

const vipplay = `${IMAGES_URL}/vipplay.png`;
const vipplayBlack = `${IMAGES_URL}/black-vipplay.png`;
const megogo = `${IMAGES_URL}/megogo.png`;
const start = `${IMAGES_URL}/start.png`;

enum LabelTypes {
    megogo = 'megogo',
    vipplay = 'vipplay',
    start = 'start',
    vipplayBlack = 'vipplayBlack',
}

enum LabelsWidth {
    megogo = '19.4%',
    vipplay = '22.6%',
    start = '13.5',
}

const LABELS = {
    [LabelTypes.megogo]: { src: megogo, width: LabelsWidth.megogo },
    [LabelTypes.vipplay]: { src: vipplay, width: LabelsWidth.vipplay },
    [LabelTypes.start]: { src: start, width: LabelsWidth.start },
    [LabelTypes.vipplayBlack]: { src: vipplayBlack, width: LabelsWidth.vipplay },
};

interface IMovie {
    name: string,
    age?: number,
    type?: LabelTypes,
}

const getUrls = (path: string, names: IMovie[]) => {
    return names.map(({ name, age, type }) => {
        const label = type && LABELS[type];
        return {
            src: `${path}${name}-min.jpg`,
            age,
            label,
        };
    });
};

const FILMS = getUrls(FILMS_URL, [
    { name: 'one-plus-one', age: 18 },
    { name: 'made-in-usa', age: 18 },
    { name: 'world-period', age: 16 },
    { name: 'gatsbi', age: 16 },
    { name: 'forsaj', age: 12 },
    { name: 'interstellar', age: 16 },
    { name: 'venom', age: 16, type: LabelTypes.vipplay },
    { name: 'holop', age: 12 },
    { name: 'text', age: 18 },
    { name: 'baby-on-drive', age: 18, type: LabelTypes.vipplay },
    { name: 'bogem5', age: 18 },
    { name: 'get-knifes', age: 16 },
]);

const SERIALS = getUrls(SERIALS_URL, [
    { name: 'white-queen', age: 18, type: LabelTypes.vipplay },
    { name: 'berlin', age: 16 },
    { name: 'besprincip', age: 18 },
    { name: 'lasts', age: 18 },
    { name: 'jail', age: 18 },
    { name: 'citchen', age: 16 },
    { name: 'ip', age: 16, type: LabelTypes.start },
    { name: 'eva', age: 18 },
    { name: 'tabu', age: 18 },
    { name: 'rivera', age: 16 },
    { name: 'bad-doctor', age: 18 },
    { name: 'mediator', age: 18 },
]);

const TV_CHANNELS = getUrls(TV_CHANNELS_URL, [
    { name: '1' },
    { name: 'r1' },
    { name: 'match' },
    { name: 'ntv' },
    { name: 'friday' },
    { name: 'tnt' },
    { name: 'sts' },
    { name: 'gold-collection' },
    { name: 'movie' },
    { name: 'euro' },
    { name: 'a' },
    { name: 'discovery' },
    { name: 'mult' },
    { name: 'vip' },
]);

const SPORT = getUrls(SPORT_URL, [
    { name: 'match-premier' },
    { name: 'm-1' },
    { name: 'game' },
    { name: 'khl-tv' },
    { name: 'boks' },
    { name: 'eurosport-1' },
    { name: 'eurosport-2' },
    { name: 'match-sport' },
    { name: 'fighter' },
    { name: 'viju' },
    { name: 'rex' },
    { name: 'motosport' },
    { name: 'match-country' },
    { name: 'match-arena' },
]);

const KIDS = getUrls(KIDS_URL, [
    { name: 'three-heroes', age: 6, type: LabelTypes.vipplay },
    { name: 'masha', age: 0 },
    { name: 'belka-and-strelka', age: 0 },
    { name: 'planet-51', age: 12 },
    { name: 'rebbit-pitter-2', age: 6 },
    { name: 'monsters-on-weekend', age: 6 },
    { name: 'i', age: 0 },
    { name: 'trolli', age: 0 },
    { name: 'angry-birds', age: 6, type: LabelTypes.vipplay },
    { name: 'spiderman', age: 16 },
    { name: 'family-kruds', age: 6, type: LabelTypes.vipplayBlack },
    { name: 'smeshariki', age: 0 },
]);

export const TABS = [
    { label: 'Фильмы', images: FILMS },
    { label: 'Сериалы', images: SERIALS },
    { label: 'ТВ-каналы', images: TV_CHANNELS },
    { label: 'Спорт', images: SPORT },
    { label: 'Детям', images: KIDS },
];
